import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/common/SEO";
import { getPageSeo } from "@/lib/seo";

const NotFoundPage = () => {
  const seo = getPageSeo("notfound");
  return (
    <section className="min-h-[80vh] flex items-center justify-center pt-32">
      <SEO
        title={seo.title}
        description={seo.description}
        robots="noindex,nofollow"
        noIndex
      />
      <div className="container-narrow text-center">
        <p className="text-[12px] tracking-[0.32em] uppercase text-[color:var(--sp-gold)]">
          404 — Lost in transit
        </p>
        <h1 className="font-display text-5xl md:text-7xl mt-4">
          A page that’s yet to be built.
        </h1>
        <p className="mt-6 text-white/70 max-w-xl mx-auto">
          The address you’ve typed isn’t part of the Seetai blueprint. Let’s
          return to the masterplan.
        </p>
        <Link to="/" data-testid="notfound-back-home" className="btn-gold inline-flex mt-10 px-6 py-3 text-[12px] tracking-[0.22em] uppercase">
          Return Home
        </Link>
      </div>
    </section>
  );
};

export default NotFoundPage;
